export const getIconStyles = (status: string) => {
    switch (status) {
      case 'BLOCKED':
        return {
          color: 'neutral.90',
          bg: 'white',
          border: '1px solid',
          borderColor: 'secondary.60',
          borderRadius: '50%',
        }
      case 'EMPTY':
        return {
          color: 'tertiary.500',
          bg: 'tertiary.30',
          border: '1px solid',
          borderColor: 'tertiary.40',
          borderRadius: '50%',
        }
      case 'FILLED':
        return {
          color: 'white',
          bg: 'tertiary.500',
          border: '1px solid',
          borderColor: 'tertiary.500',
          borderRadius: '50%',
        }
      default:
        return {
          color: 'white',
          bg: 'tertiary.500',
          border: '1px solid',
          borderColor: 'tertiary.500',
          borderRadius: '50%',
        }
    }
  }
  
  export const styleStepper = (index: number, status: string) => {
    const iconStyles = getIconStyles(status)
  
    return {
      alignItems: 'center',
      _before: {
        content: '""',
        position: 'absolute',
        width: '44px',
        height: '40px',
        bg: iconStyles.bg,
        border: iconStyles.border,
        borderColor: iconStyles.borderColor,
        zIndex: -1,
        borderRadius: '50%',
        boxShadow: '0 0 0 5px white',
      },
      _after: {
        content: '""',
        position: 'absolute',
        width: '1px',
        height: '110%',
        bg: 'secondary.80',
        zIndex: -2,
        left: '22px',
        top: index === 1 ? '50%' : '-50%',
      },
    }
  }
  
  export const styleCard = (status: string) => ({
    p: '24px',
    borderRadius: '8px',
    alignItems: 'center',
    flex: 1,
    minH: '152px',
    border: '1px solid',
    borderColor: 'secondary.60',
    bg: status !== 'BLOCKED' ? 'white' : 'grey.50',
    color: status === 'BLOCKED' ? 'neutral.90' : '',
  })
  